/*
 view_paymentform
 */
/* the methodList-object is tightly coupled to state structure in paymentmethods.js.
 The methodList-object is sorted on keys equal to the id of a paymentmethod.
 This id is also used to define the method to handle data published from this module.(view_paymentform.js)
 This method validate the equality of the actual key and the id in the structure. */
import actions from '../../common/lib/utils/actions.js';
import core from '../../common/lib/core.js';
import methodList from './deposit-form-template-conf.js';
import viewAmountfeeCreator from './view-amountfee.js';
import viewAmountinputCreator from './view-amountinput.js';
import viewAmountselectCreator from './view-amountselect.js';
import viewMethodsCreator from './view-methods.js';
import viewNotification from '../../commonview/lib/view-notification.js';
import viewPaymentMethodLink from './view-payment-method-link.js';
import viewCurrencySelectCreator from './view-currencyselect.js';
import viewSubmitBtnCreator from '../../commonview/lib/view-submitbtn.js';
import viewTextkeys from '../../commonview/lib/view-textkeys.js';

const create = core.create;
const classnameShow = 'u-show';
const classnameHide = 'u-hide';
let currentMethod;
let textkeysObj;
let elements;
let viewConfirmMethodBtn;
let viewDepositBtn;
let viewAmountInput;
let viewAmountselect;
let viewAmountfee;
let viewChangeMethodBtn;
let viewCurrencySelect;
let viewMethods;
let limitWithin;

function createMethodsTitle(txt) {
	const elm = create({
		type: 'legend',
		class: 'legend'
	});
	if (txt) {
		elm.innerHTML = txt;
	}
	return elm;
}

function changeNavDepositTitle(text) {
	// TODO; this is a temporary solution in wait for a new created by react components
	// This title belongs to the navigation, which means that each new view (pendingwithdraw,
	// bonus, payment, result) will have it's separate title. To display a new title when
	// paymentmethod or amount is selected means by this convention that two separate
	// urls have to be specified.
	elements.navdeposittitle = (elements.navdeposittitle || document.querySelector('#js-deposit-header-title'));
	if (elements.navdeposittitle && text) {
		elements.navdeposittitle.innerHTML = text;
	}
}

function getCurrentMethodId() {
	return methodList.getCurrentPaymentMethodId();
}

function show(elm) {
	if (elm) {
		core.removeClass(elm, classnameHide);
		core.addClass(elm, classnameShow);
	}
}

function hide(elm) {
	core.removeClass(elm, classnameShow);
	core.addClass(elm, classnameHide);
}

function evaluateForm() {
	// during refactoring of the paymentmodules,(view-creditcard, view-trustly etc.) towards
	// a common api and structure, the current method might be used in two ways. The
	// preferred way is the 'currentMethod.evalInput()' below.
	const valA = ((currentMethod && currentMethod.evalInput) ? currentMethod.evalInput() : null);
	const valB = methodList.evalInput();
	return (valA || valB);
}

function depositBtnCb() {
	/* .... to prevent the form to be submitted with an amount that has not been validated to
	fees and limits, a promise is added to the actions payload, to ... TODO: explanation */
	let validateFeesAndLimitsPromiseResolver;
	const promise = new Promise((resolve) => {
		validateFeesAndLimitsPromiseResolver = resolve;
	});

	actions.validateFeesAndLimitsAtSubmit(validateFeesAndLimitsPromiseResolver);

	promise.then(() => {
		/* when all credentials and amount are filled in properly */
		const inputExceptAmount = evaluateForm();
		const validAmount = viewAmountInput.getValidAmount();
		const data = inputExceptAmount;
		if (inputExceptAmount && validAmount && limitWithin) {
			data.methodId = getCurrentMethodId();
			data.am = validAmount;
			actions.viewPaymentformSubmit(data);
		}
	});
}

function showAmountSelector() {
	if (methodList.displayAmountSelector()) {
		viewAmountselect.show();
	}
}

function showCurrencySelector() {
	if (methodList.displayCurrencySelector()) {
		viewCurrencySelect.show();
	} else {
		viewCurrencySelect.hide();
	}
}

function setupForInputMethod(selectedPaymentMethodId) {
	actions.viewPaymentform({
		setupmethod: true,
		selectedPaymentMethod: selectedPaymentMethodId
	});
	changeNavDepositTitle(textkeysObj['deposit-paymentmethods-method-title']);
	show(elements.wrapmethods);
	if (viewAmountselect && viewAmountselect.hide) {
		viewAmountselect.hide();
	}
	showCurrencySelector();
	viewMethods.show();
	viewConfirmMethodBtn.show();
	viewAmountInput.hide();
	viewDepositBtn.hide();
	viewAmountfee.hide();
	viewChangeMethodBtn.hide();
	show(elements.wrapCurrent);
	hide(elements.scrollableContent);
}

function setupForInputAmount() {
	changeNavDepositTitle(textkeysObj['deposit-paymentmethods-amount-title']);
	showAmountSelector();
	if (viewCurrencySelect && viewCurrencySelect.hide) {
		viewCurrencySelect.hide();
	}
	hide(elements.wrapmethods);
	viewMethods.hide();
	viewConfirmMethodBtn.hide();
	viewAmountInput.show(methodList.disableamountinput());
	viewDepositBtn.show();
	viewAmountfee.show();
	viewChangeMethodBtn.show();
	hide(elements.wrapCurrent);
	show(elements.scrollableContent);
}

function submitbtnCallback() {
	/* when credentials for the selected method are filled in properly */
	const inputExceptAmount = evaluateForm();
	/* except amountfield*/
	if (inputExceptAmount) {
		setupForInputAmount();
	}
}

function assembleElements() {
	if (!elements.assembled) {
		elements.form = (elements.form || create('form', 'payment__form js-payment__form u-height-100'));
		elements.wrapCurrent = (elements.wrapCurrent || create('fieldset', 'payment__form__wrapcurrent'));
		elements.wrapmethods = (elements.wrapmethods || create('fieldset', 'payment__fieldset-wrap-methods custom-select u-relative u-mb2'));
		elements.wrapsubmit = (elements.wrapsubmit || create('div', 'js-payment__btn-deposit u-btn-wrapper u-absolute u-pos-bl0 grid-u-sm-1'));
		elements.wrapChangemethod = (elements.wrapChangemethod || create('ul', 'link-list js-event-filter-payment-method-link u-mb1'));
		elements.wrapamountfee = (elements.wrapamountfee || create('div', 'js-payment__wrap-amountfee payment__wrap-amountfee u-height-100'));
		elements.scrollableContent = (elements.scrollableContent || create('div', 'content-scroller u-oa u-height-100'));
		viewAmountselect = (viewAmountselect || viewAmountselectCreator.create());
		viewCurrencySelect = viewCurrencySelect || viewCurrencySelectCreator.create();
		elements.form.appendChild(viewAmountselect.wrap);
		viewAmountInput = (viewAmountInput || viewAmountinputCreator.create({
			clickcb: showAmountSelector
		}));
		elements.scrollableContent.appendChild(viewAmountInput.wrap);
		elements.form.appendChild(elements.wrapmethods);
		elements.form.appendChild(viewCurrencySelect.wrap);
		elements.form.appendChild(elements.wrapCurrent);
		elements.scrollableContent.appendChild(elements.wrapamountfee);
		// Move of the method-link out of scrollableContent to be grouped with submitdepositbutton
		elements.form.appendChild(elements.scrollableContent);
		elements.form.appendChild(elements.wrapsubmit);
		/* insert select list with options to update the rest of the form depending on the selected option
		see viewMethods.init() and viewAmountfee.init() below
		*/
		viewConfirmMethodBtn = (viewConfirmMethodBtn || viewSubmitBtnCreator.create({
			buttonText: textkeysObj['deposit-payment-method-selected-submitbtn'],
			cb: submitbtnCallback
		}));
		viewDepositBtn = (viewDepositBtn || viewSubmitBtnCreator.create({
			buttonText: textkeysObj['deposit-payment-action-submitbtn'],
			cb: depositBtnCb
		}));
		viewAmountfee = (viewAmountfee || viewAmountfeeCreator.create());
		viewChangeMethodBtn = (viewChangeMethodBtn || viewPaymentMethodLink.create({
			cb: setupForInputMethod
		}));
		viewMethods = (viewMethods || viewMethodsCreator.create());
		elements.methodsTitle = (elements.methodsTitle || createMethodsTitle(textkeysObj['deposit-inputfieldtitle-selectmethod']));
		elements.wrapmethods.appendChild(elements.methodsTitle);
		elements.wrapmethods.appendChild(viewMethods.wrap);
		elements.wrapChangemethod.appendChild(viewChangeMethodBtn.wrap);
		elements.wrapsubmit.appendChild(elements.wrapChangemethod);
		elements.wrapsubmit.appendChild(viewDepositBtn.wrap);
		elements.wrapsubmit.appendChild(viewConfirmMethodBtn.wrap);
		elements.wrapamountfee.appendChild(viewAmountfee.wrap);
		elements.wrap.appendChild(elements.form);
		elements.assembled = true;
	}
}

function createCurrentForm(p) {
	/* a 'redirect' to implement the selected paymentmethod*/
	const newId = p.newId;
	const paymentMethodsState = p.state;
	const formTemplateCode = paymentMethodsState.paymentmethods.methods.by_id[newId].formTemplateCode;
	// const formTemplateUrl = paymentMethodsState.paymentmethods.formTemplateCode[formTemplateCode];

	const params = {
		wrap: elements.wrapCurrent
	};
	currentMethod = methodList.init(newId, formTemplateCode, params);
	if (currentMethod && currentMethod.wrap) {
		elements.wrapCurrent.appendChild(currentMethod.wrap);
	}
	if (currentMethod && currentMethod.update) {
		currentMethod.update(paymentMethodsState);
	} else {
		methodList.updateCurrent(paymentMethodsState);
	}
}

function deleteAllElements() {
	/* The object-property must either contain an element or an array with elements*/
	/* The wrapper is not deleted.*/
	viewMethods = viewMethods && viewMethods.close();
	if (methodList && methodList.close) {
		methodList.close();
	}
	viewAmountfee = ((viewAmountfee && viewAmountfee.close) ? viewAmountfee.close() : null);
	viewConfirmMethodBtn = ((viewConfirmMethodBtn && viewConfirmMethodBtn.close) ? viewConfirmMethodBtn.close() : null);
	viewDepositBtn = ((viewDepositBtn && viewDepositBtn.close) ? viewDepositBtn.close() : null);
	viewChangeMethodBtn = ((viewChangeMethodBtn && viewChangeMethodBtn.close) ? viewChangeMethodBtn.close() : null);
	viewAmountInput = ((viewAmountInput && viewAmountInput.close) ? viewAmountInput.close() : null);
	viewAmountselect = ((viewAmountselect && viewAmountselect.close) ? viewAmountselect.close() : null);
	viewCurrencySelect = ((viewCurrencySelect && viewCurrencySelect.close) ? viewCurrencySelect.close() : null);
	viewNotification.close();
	if (elements) {
		elements = core.deleteElementsInObjectExcept(elements, ['wrap', 'textkeys', 'navdeposittitle'], 'view_paymentform:399');
	}
}

export default {
	init(p) {
		elements = {};
		elements.wrap = core.getElementIfValid(p, 'wrap', 'view_paymentform:419');
		textkeysObj = viewTextkeys.depositflow();
		// viewCurrencySelect = viewCurrencySelect || viewCurrencySelectCreator.create();
		// elements.form.appendChild(viewCurrencySelect.wrap);
		assembleElements();
		/* 'reset' stage */
		setupForInputMethod();
	},
	update(state) {
		const newId = ((state.paymentmethods && state.paymentmethods.selected) && state.paymentmethods.selected.id);
		const lastMethodError = (state.fetch_methoddetails && state.fetch_methoddetails.error);
		const methodName = ((state.paymentmethods && state.paymentmethods.selected) && state.paymentmethods.selected.text);
		const submitPaymentCard = ((state.submit_payment && state.submit_payment.currentcard) && (state.submit_payment.currentcard.card || null));
		const submitPaymentCn = (submitPaymentCard && submitPaymentCard.cn);
		let selectlist;
		assembleElements();

		if (state.paymentmethods) {
			viewMethods.update(state);
			if (newId) {
				/* 'reset' stage */
				setupForInputMethod();
				if (currentMethod && currentMethod.close) {
					currentMethod.close();
				} else {
					methodList.closeCurrent();
				}
				createCurrentForm({
					newId,
					methodName,
					state
				});
				setupForInputMethod(newId); // repeated to sync the currencylist display
				// currently the 'viewChangeMethodBtn' can be updated in several ways, from 'update' api with
				// a key tightly connected to this module, or by supplying the 'state' object, and also from the
				// callback attached during initialization with 'view-payment-method-link'. The callback is there
				// to execute something when the button is used, and the update-methods are used to change the
				// text or other content occassionally.

				viewChangeMethodBtn.update({
					view_paymentform: {
						name: (methodName || 'methodname:view_paymentform')
					}
				});
				viewAmountInput.update(state);
			}
		}
		/* if the payment method has been used before the current form may be updated.*/
		if (lastMethodError) {
			viewNotification.show({
				titleTxt: null,
				mainTxt: `${textkeysObj['paymentform-error-using-method']} : ${lastMethodError}`
			});
		} else if (state.fetch_methoddetails) {
			// replaceAmount(.....find last amount ....)
			/* get current method and update. The modules used are listed in the methodList-array above.*/
			/* details about current selected account is available here */
			if (currentMethod && currentMethod.update) {
				currentMethod.update(state);
			} else {
				methodList.updateCurrent(state);
			}
			/* a method that allows currency-shifting is used (skrill, ...)*/
			viewCurrencySelect.update(state);
			viewChangeMethodBtn.update(state);
			viewAmountInput.update(state);
		}
		if (state.fetch_fees_and_limits) {
			viewAmountfee.update(state);
			viewAmountInput.update(state);
			if (methodList.displayAmountSelector()) {
				viewAmountselect.update(state);
			}
			limitWithin = state.fetch_fees_and_limits.limitWithin;
			const limitAbove = state.fetch_fees_and_limits.limitAbove;
			const limitBelow = state.fetch_fees_and_limits.limitBelow;
			const limitReached = state.fetch_fees_and_limits.limitReached;
			if (limitAbove || limitBelow || limitReached) {
				viewDepositBtn.disable();
			} else if (limitWithin) {
				viewDepositBtn.enable();
			}
		}
		if (state.submit_payment) {
			/* disable payment on successful payment */
			/* go to method-view if error occurs. */
			if (state.submit_payment.amount) {
				viewAmountInput.update(state);
			}
			if (state.submit_payment.error) {
				setupForInputMethod();
			}
			if (submitPaymentCn) {
				viewChangeMethodBtn.update(state);
			}
			if (currentMethod && currentMethod.update) {
				currentMethod.update(state);
			} else {
				methodList.updateCurrent(state);
			}
		}

		if (state.first_time_uk_deposit) {
			/* Takes care of displaying the set limit link for UK first deposit users */
			viewAmountInput.update(state);
		}
		if (state.fetch_currencies) {
			selectlist = state.fetch_currencies && state.fetch_currencies.selectlist;
			viewCurrencySelect.update({
				selectlist
			});
		}
	},
	close() {
		deleteAllElements();
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/payment/lib/view-paymentform.js